module.exports = __webpack_public_path__ + "static/media/medium_larg_linee.c8f704fd.svg";